import { createContext, useContext } from "react";

// Which organisation of a group the client shell is looking at. Provided by
// ClientLayout for a user on a group's parent organisation with group:view;
// absent (the default below) everywhere else, including the consultant
// read-through, where the group overview renders without switch controls.

export interface GroupView {
  /** Null while looking at the user's own (parent) organisation. */
  viewingOrgId: string | null;
  /** Switch the whole client shell to a member of the group (null = back to the parent). */
  setViewingOrg: (orgId: string | null) => void;
  /** False when no switcher is available in this shell. */
  available: boolean;
}

export const GroupViewContext = createContext<GroupView>({ viewingOrgId: null, setViewingOrg: () => {}, available: false });

export function useGroupView(): GroupView {
  return useContext(GroupViewContext);
}
